import React, {useEffect} from 'react'
import {useIntl} from 'react-intl'
import {useDispatch, useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {
  getSortByLabels,
  shouldShowSortByWithDistance
} from 'components/SortBy/helpers'
import {useSortBy} from 'hooks/useSortBy'
import {getSearchType} from 'modules/sapiSearch/selectors'

import {InputSelect} from '@vio/atlas/InputSelect'
import {useBrand} from '@vio/core/src/_web/brand/hooks/useBrand'
import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {Action, Category, Entity} from '@vio/core/src/analytics/types/Events'

import {SORT_BY, SORT_BY_WITH_DISTANCE, SortByTypeItem} from './constants'

const SortByWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-self: flex-end;
  padding: 1px 0;
  width: 220px;
`

export const SortByDesktop: React.FC = () => {
  const {onChangeSort, sortParams} = useSortBy()
  const dispatch = useDispatch()
  const {formatMessage} = useIntl()
  const {sortField: sortSelectedField, sortOrder: sortSelectedOrder} =
    sortParams
  const {brand} = useBrand()
  const sortLabels = getSortByLabels()
  const searchType = useSelector(getSearchType)
  const sortByList = shouldShowSortByWithDistance(searchType)
    ? SORT_BY_WITH_DISTANCE
    : SORT_BY

  const activeSortByField = sortByList.find(
    item =>
      item.sortField === sortSelectedField &&
      item.sortOrder === sortSelectedOrder
  )

  const [currentSort, setCurrentSort] = React.useState(activeSortByField)

  useEffect(() => {
    setCurrentSort(activeSortByField)
  }, [activeSortByField])

  const handleChangeSort = (newSort: string) => {
    const details = JSON.parse(newSort) as SortByTypeItem
    if (!details) return
    setCurrentSort(details)
    onChangeSort({sortField: details.sortField, sortOrder: details.sortOrder})

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement?.blur()
    }
  }
  const handleOpenList = () => {
    dispatch(
      trackEvent({
        category: Category.User,
        entity: Entity.SortButton,
        action: Action.Clicked
      })
    )
  }

  const tier = brand.tierLabel

  return (
    <SortByWrapper>
      <InputSelect
        size="sm"
        onChange={handleChangeSort}
        value={JSON.stringify(currentSort)}
        onClick={handleOpenList}
        ariaLabel={formatMessage({
          id: 'sortBy',
          defaultMessage: 'Sort by'
        })}
      >
        {sortByList.map(item => (
          <option key={item.key} value={JSON.stringify(item)}>
            {formatMessage(sortLabels[item.key], {tier})}
          </option>
        ))}
      </InputSelect>
    </SortByWrapper>
  )
}
